import { redirect } from "react-router-dom";
import CheckToken from "../../services/CheckToken";
import checkModules from "../../services/checkModules";
import getModules from "../../services/getModules";

export default async function checkAuthenticated(setCheckLogin, request) {
  try {
    const isAuthenticated = await CheckToken();

    const verifyModules = window?.config?.REACT_APP_VERIFY_MODULES || "";
    if (verifyModules === "true") {
      await checkModules();
    }

    const easyMapsOnly =
      window?.config?.REACT_APP_EASYMAPS_ONLY === "true" || false;
    const nextUrl = new URL(request.url);
    const nextPath = nextUrl.pathname;
    ///configuracoes/administracao
    if (easyMapsOnly) {
      if (
        (!nextPath.includes("/easyMaps") &&
          !nextPath.includes("/configuracoes")) ||
        nextPath.includes("/configuracoes/easyLogs") ||
        nextPath.includes("/configuracoes/easyReport")
      ) {
        return redirect("/easyMaps/grupos");
      }
    }

    const modules = await getModules();

    if (isAuthenticated == false) {
      setCheckLogin(false);
      localStorage.clear();
      return redirect("/login");
    } else {
      setCheckLogin(true);
      for (const [product, isEnabled] of Object.entries(modules)) {
        if (
          nextPath.toLowerCase().includes(product.toLowerCase()) &&
          isEnabled === false
        ) {
          return redirect("/homeIn");
        }
      }
      return null;
    }
  } catch (e) {
    console.error(e);
  }
}
